import type {
  IDistributablePointReport,
  IPointResetReport,
  IPostBasedDetailedReport,
  ISpendablePointReport,
} from '@/types/Data'
import type {
  IDateRange,
  IGetDistributablePointReport,
  IGetDistributablePointReportExcel,
  IGetPointResetReport,
  IGetPostBasedDetailedReport,
  IGetSpendablePointReport,
  IGetSpendablePointReportExcel,
} from '@/types/Request'
import BaseService from '../BaseService'

export default class PointReportServices extends BaseService {
  /* GetPointReport(payload) {
    return this.POST(this.PATHS.GET_POINT_REPORT, payload);
  } */

  GetPostDetailReport(payload: IGetPostBasedDetailedReport) {
    return this.POST<IPostBasedDetailedReport[]>(this.PATHS.GET_POST_DETAIL_REPORT, payload)
  }

  GetSpendablePointReport(payload: IGetSpendablePointReport) {
    return this.POST<ISpendablePointReport[]>(this.PATHS.GET_SPENDABLE_POINT_REPORT, payload)
  }

  GetDistributablePointReport(payload: IGetDistributablePointReport) {
    return this.POST<IDistributablePointReport[]>(
      this.PATHS.GET_DISTRIBUTABLE_POINT_REPORT,
      payload,
    )
  }

  GetPointResetReport(payload: IGetPointResetReport) {
    return this.POST<IPointResetReport[]>(this.PATHS.GET_POINT_RESET_REPORT, payload)
  }

  GetPostDetailReportExcel(payload: IDateRange) {
    return this.EXCEL(this.PATHS.GET_POST_DETAIL_REPORT_EXCEL, false, payload)
  }

  GetSpendablePointReportExcel(payload: IGetSpendablePointReportExcel) {
    return this.EXCEL(this.PATHS.GET_SPENDABLE_POINT_REPORT_EXCEL, true, payload)
  }

  GetSpendablePointReportDetailExcel(payload: IGetSpendablePointReportExcel) {
    return this.EXCEL(this.PATHS.GET_SPENDABLE_POINT_REPORT_DETAIL_EXCEL, true, payload)
  }

  GetDistributablePointReportExcel(payload: IGetDistributablePointReportExcel) {
    return this.EXCEL(this.PATHS.GET_DISTRIBUTABLE_POINT_REPORT_EXCEL, true, payload)
  }

  GetDistributablePointReportDetailExcel(payload: IGetDistributablePointReportExcel) {
    return this.EXCEL(this.PATHS.GET_DISTRIBUTABLE_POINT_REPORT_DETAIL_EXCEL, true, payload)
  }

  GetPointResetReportExcel(payload: IGetPointResetReport) {
    return this.EXCEL(this.PATHS.GET_POINT_RESET_REPORT_EXCEL, false, payload)
  }
}
